var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopIcon20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7942_174580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.09 17.05C18.89 15.24 20 12.75 20 10C20 4.49 15.51 0 10 0C7.25 0 4.76 1.11 2.95 2.91C2.95 2.91 2.93 2.91 2.93 2.93C2.93 2.95 2.93 2.95 2.91 2.95C1.11 4.76 0 7.25 0 10C0 15.51 4.49 20 10 20C12.75 20 15.24 18.89 17.05 17.09C17.05 17.09 17.07 17.09 17.07 17.07C17.07 17.05 17.07 17.05 17.09 17.05ZM18 10C18 11.85 17.37 13.54 16.31 14.9L5.1 3.69C6.46 2.64 8.15 2 10 2C14.41 2 18 5.59 18 10ZM2 10C2 8.15 2.63 6.46 3.69 5.1L14.9 16.31C13.54 17.36 11.85 18 10 18C5.59 18 2 14.41 2 10V10Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7942_174580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopIcon20);
export default __webpack_public_path__ + "static/media/StopIcon-20.6e49a6cd744bdf2f285382f657d5a584.svg";
export { ForwardRef as ReactComponent };